export default __webpack_public_path__ + "static/logo-white-fbad71b5b4bb613e11ba6d135f4871b0.svg";